// main.js

import { createApp } from 'vue';
import { Capacitor } from '@capacitor/core';
import { SplashScreen } from '@capacitor/splash-screen';
import { Device } from '@capacitor/device';
import { App } from '@capacitor/app';

import { SendError } from '@/helpers.js';

import MainApp from '@/App.vue';
import router from '@/router/router';
import store from '@/store/store';

// Head
import { createHead } from '@unhead/vue';
const Head = createHead();

// Cookies
import VueCookies from 'vue-cookies';

// Quasar
import { Quasar, Notify, Dialog } from 'quasar';
import '@quasar/extras/material-icons/material-icons.css';

// SCSS
import '@/assets/scss/app.scss';

// TOUCH EVENTS
import Vue3TouchEvents from 'vue3-touch-events';
import { cleanAllCachedData } from './database.js';

// FIREBASE
import { auth } from './firebaseConfig.js';
import { authStateChange } from './firebaseListeners.js';

// SENTRY
import { initSentry, Sentry } from '@/vendors/Sentry';

// POSTHOG
import { initPosthog } from '@/vendors/Posthog.js';

// APP
let VueApp;

const initApp = async () => {
  try {
    // Get Device
    const device = await Device.getInfo();
    window.device = device;

    if (!VueApp) {
      VueApp = createApp(MainApp);

      // Prototypes
      VueApp.config.globalProperties.window = window;

      // SENTRY
      initSentry(VueApp);

      // POSTHOG
      initPosthog(VueApp);

      VueApp.use(router)
        .use(Head)
        .use(store)
        .use(VueCookies)
        .use(Vue3TouchEvents, {
          dragFrequency: 12.5,
        })
        .use(Quasar, {
          plugins: {
            Notify,
            Dialog,
          },
          config: {
            notify: {
              /* look at QuasarConfOptions from the API card */
            },
          },
        })
        .mount('#app');

      await cleanAllCachedData();

      if (Capacitor.isNativePlatform()) {
        await SplashScreen.hide();
      }

      App.addListener('appUrlOpen', function (event) {
        const path = event.url.split('sales.voizor.com').pop();

        if (path) {
          router.push(path);
        }
      });
    }
  } catch (err) {
    Sentry.captureException(err);
    SendError(err);
  }
};

auth.onAuthStateChanged(async (user) => {
  await authStateChange(user);
  await initApp();
});

// EOF
